<template>
  <div id="app">
    <div class="page-content" :class="{ 'with-bottom-nav': showBottomNav }">
      <router-view></router-view>
    </div>
    <nav class="bottom-nav" v-if="showBottomNav">
      <router-link to="/" exact class="nav-item">
        <img :src="currentPath === '/' ? homeActiveIcon : homeBaseIcon" alt="首页" class="nav-icon" />
        <span>首页</span>
      </router-link>
      <router-link to="/member" exact class="nav-item">
        <img :src="currentPath === '/member' ? memberActiveIcon : memberBaseIcon" alt="我的" class="nav-icon" />
        <span>我的</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import homeBaseIcon from '@/assets/nav_icon/home_base.png'
import homeActiveIcon from '@/assets/nav_icon/home_active.png'
import memberBaseIcon from '@/assets/nav_icon/member_base.png'
import memberActiveIcon from '@/assets/nav_icon/member_active.png'

export default {
  name: 'App',
  computed: {
    currentPath() {
      return this.$route.path
    },
    showBottomNav() {
      return ['Home', 'Member'].includes(this.$route.name)
    }
  },
  data() {
    return {
      homeBaseIcon,
      homeActiveIcon,
      memberBaseIcon,
      memberActiveIcon
    }
  }
}
</script>

<style>
@import '@/assets/font/iconfont.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
}

.page-content.with-bottom-nav {
  padding-bottom: 60px; /* 给底部导航留出空间 */
}

.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 56px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #eaeaea;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.05);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #666;
  font-size: 12px;
  line-height: 1;
  padding: 6px 0;
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}

.nav-item.active,
.nav-item.router-link-exact-active {
  color: #FF6600;
  font-weight: 600;
}
</style>
